/* global showOverlay, hideOverlay */

// Set constants for the DOM nodes
const mobileMenuToggle = document.querySelector( '#header-mobile-menu-toggle' );
const mobileMenuWrapper = document.querySelector( '#mobile-menu-wrapper' );
const mainContent = document.querySelector( '#content' );

// Only try to do this if the mobile menu toggle exists
if ( mobileMenuToggle ) {

	// Enable menu toggle
	mobileMenuToggle.addEventListener( 'click', function ( event ) {
		// If the menu isn't open yet
		if ( mobileMenuToggle.getAttribute( 'aria-expanded' ) === 'false' ) {

			// Stop the body from scrolling
			document.body.style.top = '-' + window.scrollY + 'px';
			document.querySelector( 'html' ).style.overflow = 'hidden';
			document.body.style.overflow = 'hidden';
			document.body.style.position = 'fixed';

			// Show the overlay
			showOverlay( 'mobile-overlay', 50 );

			// Set the menu height
			mobileMenuHeightReduction = 0;
			if ( header = document.querySelector( '#header-mobile' ) ) {
				mobileMenuHeightReduction += header.clientHeight;
			}
			if ( wpadminbar = document.querySelector( '#wpadminbar' ) ) {
				mobileMenuHeightReduction += wpadminbar.clientHeight;
			}
			mobileMenuWrapper.style.height = ( window.innerHeight - mobileMenuHeightReduction ) + 'px';

			// Show the mobile menu
			mobileMenuWrapper.style.display = 'block';

			// Set the aria-expanded attribute to true
			// The menu visibility is controlled by this attribute in CSS
			mobileMenuToggle.setAttribute( 'aria-expanded', 'true' );

			// Update the aria label
			mobileMenuToggle.setAttribute(
				'aria-label',
				mobileMenuToggle.getAttribute( 'aria-label' ).replace( 'Show', 'Hide' )
			);

		}

		// Otherwise the menu is already open
		else {

			// Allow the body to scroll again
			let scrollY = document.body.style.top;
			document.querySelector( 'html' ).style.overflow = 'visible';
			document.body.style.overflow = 'visible';
			document.body.style.position = '';
			document.body.style.top = '';
			window.scrollTo( 0, parseInt( scrollY || '0' ) * -1 );

			// Hide the mobile menu
			mobileMenuWrapper.style.display = 'none';

			// Set the aria-expanded attribute to true
			// The menu visibility is controlled by this attribute in CSS
			mobileMenuToggle.setAttribute( 'aria-expanded', 'false' );

			// Update the aria label
			mobileMenuToggle.setAttribute(
				'aria-label',
				mobileMenuToggle.getAttribute( 'aria-label' ).replace( 'Hide', 'Show' )
			);

			// Hide the overlay
			hideOverlay( 'mobile-overlay' );
		}
	} );

	// Loop through all mobile menu links with children
	document
		.querySelectorAll( '.mobile-menu-link.has-children' )
		.forEach( function ( mobileMenuItemLink ) {
			// Event listener - when this menu item link is clicked
			mobileMenuItemLink.addEventListener( 'click', function ( event ) {
				// Stop the link being followed and any propagation
				event.preventDefault();

				// Store the clicked element as a variable
				let clickedMobileMenuItemLink = event.target;

				// If the submenu isn't open yet
				if (
					clickedMobileMenuItemLink.getAttribute( 'aria-expanded' ) === 'false'
				) {
					// Set the aria-expanded attribute to true
					// The menu visibility is controlled by this attribute in CSS
					clickedMobileMenuItemLink.setAttribute( 'aria-expanded', 'true' );

					// Update the aria label
					clickedMobileMenuItemLink.setAttribute(
						'aria-label',
						clickedMobileMenuItemLink
							.getAttribute( 'aria-label' )
							.replace( 'Show', 'Hide' )
					);

					// Otherwise the submenu is already open
				} else {
					// Set the aria-expanded attribute to true
					// The menu visibility is controlled by this attribute in CSS
					clickedMobileMenuItemLink.setAttribute( 'aria-expanded', 'false' );

					// Update the aria label
					clickedMobileMenuItemLink.setAttribute(
						'aria-label',
						clickedMobileMenuItemLink
							.getAttribute( 'aria-label' )
							.replace( 'Hide', 'Show' )
					);
				}
			} );
		} );
}
